import { axiosInstance, epgCheckInstance, live_instance, axiosFileBlob_live } from "../instance";

//const beforeURL = '/api/live' //部署上线用的前缀
const beforeURL = '' // 本地
//let beforeURL = /managemango/.test(window.location.hostname)? '/api/live' : ''
/**======================================== 频道审核管理 ========================================================= */
/** 获取频道列表  */
export const getLiveChannelListApi = (pageNo, pageSize, params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/channels/${pageNo}/${pageSize}`, params})

/** 获取语言列表 */
export const getLanguageListApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/languageList`})

/** 获取字典列表 */
export const getSysDictListApi = (type) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/sysDictList`, params: {type}})

/** 获取品牌下拉列表 */
export const getsubBrandListApi = (cpspId) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/subBrandList`, params: {cpspId}})

/** 获取直播分类英文列表 */
export const getEnListApi = (cpspId) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/category/property/getEnList`})

/** 获取子品牌直播分类列表 
 * params:{cid:运营商id, keyword：关键词， codeProtocol：编码协议 0:H.264 和 1:H.265 } */
export const getCpspCategoriesApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/category/agentCategories`, params})

/** 获取国家列表 */
export const getcountryListApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/countryList`})

/** 新增频道 */
export const addChannelsApi = (params) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/channel`, data:params, type: 'json'})

/** 删除频道 */
export const deleteChannelsApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/api/web/channel`, params:{id}})

/** 批量删除频道 */
export const batchDeleteChannelsApi = (ids, cpspId) => live_instance({method: 'delete', url: `${beforeURL}/live/api/web/channel/batch`, params:{ids, cpspId}})

/** 修改频道 */
export const editChannelsApi = (params) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel`, data:params, type: 'json'})

/** 获取频道详情 */
export const getChannelDetailApi = (id) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/channel/detail`, params: {id}})

/** 修改频道审核状态 0:未审核,1:通过,2:未通过,3:终端审核,4:退回 
 * params: channelId：频道id state:审核状态  checkFailedReason:未通过审核原因
*/
export const editCheckStateApi = (params) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/checks-state`, params})

/** 修改频道上下线状态 0：未上线，1：已上线，2：已下线
 * params: channelId：频道id state:上下线状态  offlineReason:下线原因
 */
export const editReleaseStateApi = (params) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/release-state`, params})

/** 导出频道列表 */
export const exportChannelListApi = (categoryId, ids, cpspId, params?) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/channels/export`, params:{categoryId, ids, cpspId, ...params}, responseType:'blob'})

/** 导入频道
 * updateSupport:Boolean showNo重复还要继续导入时为true，默认false
 * categoryChannelId: 子品牌id，内容列表导入节目时传入
 */ 
export const importApi = (file, cpspId, type, categoryIds, codeProtocol, updateSupport, lang, channelProtocol, categoryChannelProtocol?) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/channel/import?lang=${lang}`, data:{file, cpspId, type, categoryIds, codeProtocol, updateSupport, categoryChannelProtocol, channelProtocol}, type: 'upload', responseType:'blob', timeout:600000})

/** 频道显示号重新排序 */
export const sortShowNoApi = (cpspId) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/sort`, params: {cpspId}})

/** 检查重复 */
export const checkDuplicateApi = (cpspId, attribute, value) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/channel/check-duplicate/${cpspId}/${attribute}/${value}`})

/** 修改物理频道激活状态 */
export const editPhysicalStateApi = (physicalChannelId, state) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/physical/state`, params:{physicalChannelId, state}})

/** 批量修改频道回看状态 */
export const batchChangeLookBackApi = (ids, days) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/look-back/state`, data:{ids, days}, type:'json'})

/** 清除直播节目缓存 */
export const cleanCacheApi = (cid) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/cache/live/channel`, params: {cid}})

/** 批量修改频道时移 */
export const batchChangeTimeShiftApi = (ids, min) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/channel/time-shift`, data:{ids, min}, type:'json'})

/**======================================== epg检查相关接口 ========================================================= */
/** 通过卫星角度获取epg检查列表 */
export const getCheckDataToLiveApi = (satellite) => epgCheckInstance({method: 'get', url:`/getCheckDataToLive?satellite=${satellite}`})

/** 获取单个节目的所有EPG */
export const getAllEpgApi = (startTime, endTime, channelId, lang) => epgCheckInstance({method: 'get', url:`/getEpgs?starttime=${startTime}&endtime=${endTime}&channelid=${channelId}&language=${lang}`})

/** 获取epg详情 */
export const getEpgChannelInfoApi = (channelId) => epgCheckInstance({method: 'get', url:`/getChannelInfo?id=${channelId}`})


/**======================================== 直播分类相关接口 ========================================================= */
/** 获取直播分类列表 */
export const getLiveCategoryListApi = (parentId) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/categories?parentId=${parentId}`})

/** 新增直播分类 */
export const addLiveCategoryApi = (params) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/category`, data:params, type: 'json'})

/** 获取直播分类选项列表 
 * params: 
 * parentId: 父分类栏目id
 * id: 当前分类id
 * 当parentId有值时，返回该分类下的子分类；当id有值时，返回该分类;
*/
export const getLiveCategoryOptionsApi = (params) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/options`, params})

/** 获取直播分类排序选项列表 */
export const getLiveCategorySequencesApi = (parentId) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/sequences?parentId=${parentId}`})

/** 删除直播分类 */
export const deleteLiveCategoryApi = (params) => live_instance({method: 'delete', url:`${beforeURL}/live/api/web/category`, data:params, type:'json'})

/** 修改直播分类 */
export const updateLiveCategoryApi = (params) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category`, data:params, type:'json'})

/** 更新分类的节目数量 */ 
export const updateCategorySumApi = (cpspId) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/updateSum?categoryId=${cpspId}`})

/** 同步直播分类节目 */ 
export const getSyncCategoryApi = () => live_instance({method: 'post', url:`${beforeURL}/live/api/web/category/sync`})

/** 获取分类频道列表 */
export const getCategoryChannelsApi = (params) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/channels`, params})

// 修改分类频道付费设置
export const updateCategoryChannelPaySettingApi = (data) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/channel/premium`, data, type:'json'})

// 批量更新编码标准
export const batchUpdateEncodingApi = ({channelIds, programType}) => live_instance({method: 'put', url:`/live/api/web/channel/physical/programType`, params:{channelIds, programType}, type:'json'})

/** 修改分类频道序号 */ 
export const changeChannelSequenceApi = (categoryProgramId, newSequence) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category/channel/sequence`, params:{categoryProgramId, newSequence}})

/** 修改分类频道视频解密*/
export const updateVideoEncryptionApi = (params) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category/channel/videoEncryption`, data:params, type:'json'})

/** 修改分类频道传输协议*/
export const updateTransferProtocolApi = (params) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category/channel/transferProtocol`, data:params, type:'json'})

/** 删除分类频道*/
export const deleteCategoryChannelApi = (params) => live_instance({method: 'delete', url:`${beforeURL}/live/api/web/category/channels`, data:params, type:'json'})

/** 新增分类频道 */
export const addCategoryChannelApi = (params) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/category/channels`, params, type:'json'})

/** 获取直播分类属性列表 */
export const getCategoryPropertiesApi = (pageNum, pageSize, keyword, sortKey, asc) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/properties`, params:{pageSize, pageNum, keyword, sortKey, asc}})

/** 新增分类属性 
 * (@param)array[object] {programlanguage:string, programname:string}
*/
export const addcategoryPropertyApi = (params) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/category/property`, data:params, type:'json'})

/** 获取分类属性详情 */
export const getcategoryPropertyDetailApi = (id) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/property/${id}`})

/** 删除分类属性 */
export const deleteCategoryPropertyApi = (id) => live_instance({method: 'delete', url:`${beforeURL}/live/api/web/category/property/${id}`})

/** 修改分类属性 */
export const editCategoryPropertyApi = (id, data) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category/property/${id}`, data, type:'json'})

/** 获取直播配置参数 */
export const getLiveParamsApi = (name) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/system/config/value/${name}` })

/** 修改直播配置参数 */
export const editLiveParamsApi = (name, value) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/system/config/value`, params:{name, value} })

/** 校验分类属性的添加修改 */
export const checkLiveCategoryApi = (params) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/category/property/verify`, params })

/** 修改分类频道排序  sortType:1按名称排序*/
export const updateCategorySortApi = (id, sortType) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/category/channel/sort`, params:{id, sortType} })

/**获取关联国家分类的国家列表 */
export const getCountryListOfLiveApi = () => live_instance({method: 'get', url:`/live/api/web/v2/countryList` })

/** 获取国家分类列表 */
export const getCountryCategoryListApi = (subAgentId) => live_instance({method: 'get', url:`/live/api/web/category-country/list`, params: {subAgentId} })

/** 新增国家分类 */
export const addCountryCategoryApi = (data) => live_instance({method: 'post', url:`/live/api/web/category-country`, data, type: 'json' })

/** 编辑国家分类 */
export const editCountryCategoryApi = (data) => live_instance({method: 'put', url:`/live/api/web/category-country`, data, type: 'json' })

/** 删除国家分类 */
export const delCountryCategoryApi = (countryCode, subAgentId) => live_instance({method: 'delete', url:`/live/api/web/category-country/${countryCode}`, params: {subAgentId} })

/**上传图片获取对应的url */ 
export const getImageUrlByUploadApi = (data) => live_instance({method: 'post', url:`/live/api/web/file/upload/cms_live`, data, type: 'upload' })


/**======================================== 产品运营 ========================================================= */
/** 获取服务器地址组下拉数据 */
export const getServerGroupsApi = () => live_instance({method: 'get', url:`${beforeURL}/live/api/web/server/getGroups`})

/** 生成二维码 */
export const getQrCodeApi = (categoryIds) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/qrcode`, params:{categoryIds}})


/**=======================================sn参数=================================================================== */
/**根据sn号查询sn列表*/
export const getSnListApi = (sn, pageSize, pageNo) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/sn/model/switch/list`, params: {sn, pageSize, pageNo}})

/**切换3ID*/
export const change3IdApi = (id, ids) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/sn/model/switch`, params: {id, ids}})

/** 恢复3id,即删除 */
export const recover3IdApi = (id) => live_instance({method: 'delete', url:`${beforeURL}/live/api/web/sn/model/switch`, params: {id}})

/** 新增sn+3id */
export const addSN3IdApi = (snNo, ids) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/sn/model/switch`, params: {snNo, ids}})

/** 获取本机IP+MAC */
export const getIpMacApi = () => live_instance({method: 'get', url:`${beforeURL}/live/api/web/system/config/getMacAndLocalIp` })

/** 3DES加密 */
export const encryptBy3DesApi = (password, plan) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/system/config/encryptBy3Des`, params: {password, plan} })

/** 3DES解密 */
export const decryptBy3Des3DesApi = (password, cipher) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/system/config/decryptBy3Des`, params: {password, cipher} })


/** ========================================================Net Audio============================================================ */
/**获取netAudio列表 */
export const getNetAudioListApi = (pageNo, pageSize, keyword) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/netAudio/list`, params: {pageNo, pageSize, keyword} })

/**删除Audio */
export const deleteNetAudioApi = (idList) => live_instance({method: 'delete', url:`${beforeURL}/live/api/web/netAudio`, params: {idList} })

/** 新增Audio */
export const addNetAudioApi = (params) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/netAudio`, data:params, type:'json' })

/** 编辑Audio */
export const editNetAudioApi = (params) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/netAudio`, data:params, type:'json' })

/** 编辑showNo */
export const editNetAudioShwoNoApi = (id, showNo) => live_instance({method: 'put', url:`${beforeURL}/live/api/web/netAudio/sort`, data:{id, showNo}, type:'json' })



/**================================================================激活码设置========================================================================== */
/**获取激活码信息 */
export const getActivationCodeApi = (code) => live_instance({method: 'get', url:`${beforeURL}/live/api/web/activation/code/info`, params:{code} })

/**解绑设备 */
export const unbindDeviceApi = (codes) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/activation/code/unbind`, params:{codes} })

/** 获取解绑记录 */
export const getDeviceUnbindRecordApi = (pageNo, pageSize) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/activation/code/unbind/list`, params: {pageNo, pageSize}})




/** ===================================================直播接口测试=================================================== */
/** 根据激活码获取设备id */
export const getDeviceIdByActiveCodeApi = (userId) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/activation/code/user/${userId}`})


/**======================================================客户软件版本========================================================== */
/** 根据cid和pid获取model列表 */
export const getModelsApi = (data) => live_instance({method: 'get', url: `/vod-datasource/stb/model/options`, params:data})

/**获取客户端版本数据 */
export const getSoftwareVersionApi = (data) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/softwareVersion`, params:data})

/**获取活跃用户数据 */
export const getactiveUserApi = (data) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/activeUser`, params:data})

/** 获取用户地区分布数据 */
export const getUserRegionApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/regionalDistribution`})

/** 获取国家数据*/
export const getNationListApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/nationList`})


/** ==========================================================直播批量管理===================================================================== */

/** 根据ip地址查询节目频道的数量*/
export const getChannelCountApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/batch/management/select/channel/count`, params})

/** 根据ip地址查询图片的数量 */
export const getPictureCountApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/batch/management/select/picture/count`, params})

/** 替换节目频道地址 */
export const replaceChannelAddressApi = (params) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/batch/management/replace/channel/playUrl`, params})

/**替换图片地址 */
export const replaceImgAddressApi = (params) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/batch/management/replace/picture/fileUrl`, params})


/**======================================================================直播节目统计====================================================================== */

/**获取主品牌列表 */
export const getMainBrandListApi = (cid) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/mainAgent`, params: {cid}})

/**获取子品牌列表 */
export const getSubBrandListApi = (mainAgentId) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/agent`, params:{mainAgentId}})

/** 查询表单数据 */
export const getChannelDataApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/channelData`, params})

/** 下载统计数据 */
export const downloadStatisticsApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/statistics/download`, params, responseType:'blob'})


/****************************************************************************自动化测试****************************************************************************** */
/**自动化测试的接口没有部署在跟其他接口一样的端口 所以不加beforeUrl */
/**获取账号运行任务  */
export const getTestMissionListApi = (pageNo, pageSize, params) => live_instance({method: 'get', url: `/live/auto-test/check-play/task/list/${pageNo}/${pageSize}`, params})

/** 获取测试报告 */
export const getTestReportApi = (pageNo, pageSize, params) => live_instance({method: 'get', url: `/live/auto-test/check-play/task-item/list/${pageNo}/${pageSize}`, params})

/** 获取测试设备 */
export const getTestDeviceApi = (pageNo, pageSize, params) => live_instance({method:'get', url: `/live/auto-test/check-play/account/list/${pageNo}/${pageSize}`, params})

/** 下载测试报告 */
export const downloadTestReportApi = (taskId) => live_instance({method: 'get', url: `/live/auto-test/check-play/task-item/export`, params:{taskId}, responseType:'blob'})

/** 新增测试设备 */
export const addTestDeviceApi = (snType, sn, hours) => live_instance({method:'post', url: `/live/auto-test/check-play`, data: {snType, sn, hours}, type:'json'})

/** 修改测试播放设备 */
export const editTestDeviceApi = (snType, sn, hours) => live_instance({method:'put', url: `/live/auto-test/check-play`, data: {snType, sn, hours}, type: 'json'})

/** 手动开始播放测试 */
export const startTestApi = (sn) => live_instance({method:'put', url: `/live/auto-test/check-play/start/${sn}`})

/** 停止测试 */
export const stopTestApi = (sn) => live_instance({method:'put', url: `/live/auto-test/check-play/stop/${sn}`})

/**删除播放测试 */
export const deleteTestApi = (sn) =>live_instance({method:'delete', url: `/live/auto-test/check-play/${sn}`})

/** 启用自动化播放测试/ */
export const startAutoTestApi = (sn, snType) => live_instance({method:'put', url: `/live/auto-test/check-play/start/auto/${sn}/${snType}`})


/**=========================================================================播放鉴权IP设置============================================================================= */
/** 获取IP列表 */
export const getIpListApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/ip/range/list`, params })

/** 新增IP */
export const addIpServerApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/ip/range/save`, data, type: 'json'})

/**修改IP */
export const editIpServerApi = (data) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/ip/range/update`, data, type: 'json'})

/** 删除IP */
export const deleteIpServerApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/api/web/ip/range/delete/${id}` })

/** 获取优先播放列表 */
export const getFirstPlayListAPi = (current, pageSize) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/priority/play/list/${current}/${pageSize}`})

/** 新增优先播放 */
export const addFirstPlayApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/priority/play/add`, data, type: 'json'})

/**修改优先播放列表 */
export const editFirstPlayApi = (data) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/priority/play/update`, data, type: 'json'})

/** 删除优先播放列表 */
export const deleteFirstPlayApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/api/web/priority/play/delete/${id}` })

/** 获取服务器下拉列表 */
export const getServerOptionListApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/priority/play/server/selectData`})

/** 获取服务器列表 */
export const getServerListApi = () => live_instance({method: 'get', url: `${beforeURL}/live/api/web/priority/play/server/list`})

/** 新增服务器列表 */
export const addServernListApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/priority/play/server/add`, data, type: 'json'})

/** 编辑服务器列表 */
export const editServernListApi = (data) => live_instance({method: 'put', url: `${beforeURL}/live/api/web/priority/play/server/update`, data, type: 'json'})

/** 删除服务器列表 */
export const deleteServernListApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/api/web/priority/play/server/delete/${id}`,})

/** 校验ip是否重复 */
export const verifyIpRepeatApi = (ip) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/priority/play/server/validate`, params:{ip}})

/** 校验sn/账号/激活码 */
export const verifySnAccountApi = (type, value) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/priority/play/validate`, params:{type, value}}) 


/**查询cookie配置 */
export const getCookieListApi = (params) => live_instance({method: 'get', url: `/live/api/web/cookie-config/page`, params }) 

/**新增cookie配置 */
export const addCookieApi = (data) => live_instance({method: 'post', url: `/live/api/web/cookie-config`, data, type: 'json' })

/**编辑cookie配置 */
export const editCookieApi = (data) => live_instance({method: 'put', url: `/live/api/web/cookie-config`, data, type: 'json' })

/**删除cookie配置 */
export const deleteCookieApi = (id) => live_instance({method: 'delete', url: `/live/api/web/cookie-config`, params: {id}  })

/** 获取国家列表 */
export const getIpOpenCountryListApi = () => live_instance({method: 'get', url: `/live/api/web/ip/open/country/list`})

/** 新增国家 */
export const addIpOpenCountryApi = (data) => live_instance({method: 'post', url: `/live/api/web/ip/open/country/save`, data, type: 'json' })

/** 编辑国家 */
export const editIpOpenCountryApi = (data) => live_instance({method: 'put', url: `/live/api/web/ip/open/country/update`, data, type: 'json' })

/** 删除国家 */
export const deleteIpOpenCountryApi = (id) => live_instance({method: 'delete', url: `/live/api/web/ip/open/country/delete/${id}` })

/**===============================================================================方案设置=================================================================================== */
/**获取方案组列表 */
export const getSolutionInfoApi = () => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/solution/info`})

/**更新方案 */
export const updateSolutionInfoApi = (id, params) => live_instance({method: 'put', url: `${beforeURL}/live/v2/api/web/iptv/solution/update/${id}`, params})

/**========================================平台管理======================================= */
/**获取平台列表 */
export const getPlatformListApi = (params) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/platform/level/list`, params})

/**新增平台 */
export const addPlatformListApi = (params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/platform/level/add`, params})

/**更新平台 */
export const editPlatformListApi = (id, data) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/platform/level/update/${id}`, data, type:'json'})

/**删除平台 */
export const deletePlatformListApi = (id) => live_instance({method: 'delete', url: `/live/v2/api/web/iptv/platform/level/delete/${id}`})



/**==========================================================================IPTV管理======================================================================================= */
/**获取iptv管理列表 */
export const getIptvListApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/list`, params})

/**获取详情 */
export const getIptvDetailApi = (id) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/info/${id}`, })

/** 新增IPTV */
export const addIptvApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/v2/api/web/iptv/add`, data, type:'json' })

/** 删除IPTV */
export const deleteIptvApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/v2/api/web/iptv/delete/${id}`, })

/** 修改IPTV */
export const updateIptvApi = (data) => live_instance({method: 'put', url: `${beforeURL}/live/v2/api/web/iptv/update`, data, type: 'json'})

/** 获取iptv供应商列表 */
export const getIptvProviderListApi = () => axiosInstance({method: 'get', url: `/api/authority/getCmsUserList?page=1&limit=10&roleId=36&name=`, })


/**========================================================================终端内容管理============================================================================ */
/** 获取SN组列表 */
export const getSnGroupListApi = (current, pageSize, params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/list/${current}/${pageSize}`, params })

/** 获取SN组详情*/
export const getSnGroupDetailApi = (id, current, pageSize, userType, userId) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/info/${id}/${current}/${pageSize}/${userType}/${userId}`, })

/** 添加SN组 */
export const addSnGroupApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/add`, data, type:'json' })

/** 删除SN组 */
export const deleteSnGroupApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/delete/${id}` })

/** 获取所有model */
export const getModelsAllApi = () => axiosInstance({method: 'get', url: `/api/modelConfig/modelsAll`, })

/** SN组添加SN */
export const addSnToGroupApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/addSn`, data, type:'json' })

/** sn列表添加SN  */
export const addSntoListApi = (data) => live_instance({method: 'post', url: `${beforeURL}/live/v2/api/web/iptv/sn/add`, data, type:'json' })

/** 获取方案组下拉数据 */
export const getSolutionSelectDataAPi = () => live_instance({method: 'put', url: `${beforeURL}/live/v2/api/web/iptv/solution/selectData`, })

/** SN组：编辑分组名称||备注 */
export const changeGroupNameOrRemarkApi = (data) => live_instance({method: 'put', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/save`, data, type:'json' })

/** 单独删除SN */
export const deleteSnSingleApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/delete/${id}`, })

/** 批量删除绑定的SN */
export const deleteSnBatchApi = (ids)=> live_instance({method: 'delete', url: `${beforeURL}/live/v2/api/web/iptv/sn/group/delete`, params:{ids} })

/** 获取SN列表 */
export const getIptvSnListApi = (current, pageSize, params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/sn/list/${current}/${pageSize}`, params })

/** 删除SN列表 */
export const deleteIptvSnListApi = (id) => live_instance({method: 'delete', url: `${beforeURL}/live/v2/api/web/iptv/sn/delete/${id}` })

/** 查询model列表 */
export const getIptvModelListApi = (current, pageSize, params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/relation/model/list/${current}/${pageSize}`, params })

/** 获取iptv定制信息 */
export const getIptvCustomInfoApi = (type, associationId, params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/customization/info/${type}/${associationId}`, params, timeout: 30000 })

/** 获取缓存值和IPTV限定数量 */
export const getCacheAndIptvNumApi = (ids) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/solution/cacheAndCount`, params: {ids} })

/** 修改iptv定制 */
export const updateIptvCustomApi = (type, associationIds, data) => live_instance({method: 'put', url: `${beforeURL}/live/v2/api/web/iptv/customization/update`, params: {type, associationIds}, data, type:'json' })

/** 单独添加iptv定制信息 */
export const addIptvCustomApi = (type, associationId, data) => live_instance({method: 'post', url: `${beforeURL}/live/v2/api/web/iptv/customization/add/${type}/${associationId}`,  data, type:'json' })

/** 删除验证是否有绑定关系 */
export const verifyRelationIptvApi =(id) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/delete/verify/${id}` })

/** 校验id是否重复 */
export const verifyIdApi = (id) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/verify/${id}` })

/**批量校验是否存在定制信息 */
export const verifyCustomInfoApi = (ids, type, userId, roleNames) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/customization/existsCustomization`, params: {ids, type, userId, roleNames} })

/** 校验SN是否存在 */
export const verifySnExistenseApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/sn/validate`, params })



/**========================================================================用户数据============================================================================== */
/**获取用户的iptv */
export const getUserIptvListApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/user/iptv`, params })

/**获取用户的code */
export const getUserCodeListApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/v2/api/web/iptv/user/code`, params })


/** ===============================================================SN黑名单===================================================================== */

/**获取sn黑名单列表 */
export const getSnBlackListApi = (params) => live_instance({method: 'get', url: `/live/api/web/sn/blacklist/list`, params })

/**添加SN黑名单 */
export const addSnBlackListApi = (data) => live_instance({method: 'post', url: `/live/api/web/sn/blacklist`, data, type: 'json' })

/**删除SN黑名单 */
export const deleteSnBlackListApi = (sn) => live_instance({method: 'delete', url: `/live/api/web/sn/blacklist`, params:{sn} })

/**编辑SN黑名单 */
export const editSnBlackListApi = (data) => live_instance({method: 'put', url: `/live/api/web/sn/blacklist`, data, type: 'json' })


/**===============================================================MgCam====================================================================== */
/**获取MgCam列表 */
export const getMgCamListApi = (params) => live_instance({method: 'get', url: `/mgcam-cccam-admin/v1/config/list`, params })

/**删除MgCam配置 */
export const DelMgCamListApi = (ids) => live_instance({method: 'delete', url: `/mgcam-cccam-admin/v1/config`, params: {ids} })

/**添加MgCam配置 */
export const AddMgCamListApi = (data) => live_instance({method: 'post', url: `/mgcam-cccam-admin/v1/config`, data,  type: 'json' })

/**更新MgCam配置 */
export const EditMgCamListApi = (data) => live_instance({method: 'put', url: `/mgcam-cccam-admin/v1/config`, data,  type: 'json' })

/** 获取MgCam详情 */
export const getMgCamDetailApi = (id) => live_instance({method: 'get', url: `/mgcam-cccam-admin/v1/config`, params: {id} }) 

/**获取关联的域名和端口数据 */
export const getHostAndPortApi = (operatorId, cid, reseller) => live_instance({method: 'get', url: `/mgcam-cccam-admin/v1/config/relateInputHost`, params: {operatorId, cid, reseller} }) 

/**根据host获取上次输入的port */
export const getPortByHostApi = (host, cid, reseller) => live_instance({method: 'get', url: `/mgcam-cccam-admin/v1/config/relateInputPort`, params: {host, cid, reseller} }) 


/**=============================================================Model设置===================================================================== */
/**获取Model列表 */
export const getModelCofigListApi = (params) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/control/modelList`, params })

/**获取Model设置的下拉框数据 */
export const getModelOptionsListApi = (type, params) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/relation/model/selectData/${type}`, params })

/**添加 */
export const addModelConfigListApi = (params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/control/add`, params,  })

/**更新 */
export const editModelConfigListApi = (id,params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/control/edit/${id}`, params,   })

/**删除 */
export const deleteModelConFigApi = (id) => live_instance({method: 'delete', url: `/live/v2/api/web/iptv/control/delete/${id}` })


/**=================================================================充值记录=========================================================================== */
/**获取列表 */
export const getRechargeListApi = (data) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/recharge/list`, data, type: 'json'  })

/**获取详情 */
export const getRechargeDetailApi = (orderId) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/recharge/detail`, params: {orderId} })


/**================================================================Pdash配置==================================================================== */
/**获取PDASH列表 */
export const getPdashListApi = (params) => live_instance({method: 'get', url: `/live/api/web/pdash-config/page`, params })

/**新增pdash配置 */
export const addPdashApi = (data) =>  live_instance({method: 'post', url: `/live/api/web/pdash-config`, data, type: 'json' })

/** 更新pdash配置 */
export const updatePdashApi = (data) =>  live_instance({method: 'put', url: `/live/api/web/pdash-config`, data, type: 'json' })

/** 删除pdash配置 */
export const deletePdashApi = (id) =>  live_instance({method: 'delete', url: `/live/api/web/pdash-config`, params: {id} })

/**获取内容定价产品包价格 */
export const getVodServiceInfoApi = () => live_instance({method: 'get', url: `/agent/content-pricing/list`,  })


/**获取映射3id列表 */
export const getModelMappingListApi = (params) => live_instance({method: 'get', url: `/live/api/web/modelMapping`, params: params })


/** 更新映射3id */
export const updateModelMappingApi = (data) =>  live_instance({method: 'put', url: `/live/api/web/modelMapping`, data, type: 'json' })

/** 更新映射3id */
export const addModelMappingApi = (data) =>  live_instance({method: 'post', url: `/live/api/web/modelMapping`, data, type: 'json' })
/** 删除映射3id */
export const deleteModelMappingApi = (params) => live_instance({method: 'delete', url:`/live/api/web/modelMapping`,params:params,type: 'json' })

/**查询域名配置列表 */
export const getNetFlyDomainListApi =  (params) => live_instance({method: 'get', url: `/live/api/web/netfly/domain/page`, params: params })

// 修改域名配置列表
export const editNetFlyDomainApi = (data) =>  live_instance({method: 'put', url: `/live/api/web/netfly/domain`, data, type: 'json' })

// 新增域名配置列表
export const addNetFlyDomainApi = (data) =>  live_instance({method: 'post', url: `/live/api/web/netfly/domain`, data, type: 'json' })

// 删除域名配置列表
export const deleteNetflyDomainApi = (params) => live_instance({method: 'delete', url:`/live/api/web/netfly/domain`,params:params,type: 'json' })


/**===========================================================终端应用设置=================================================================== */
// 获取终端应用设置列表
export const getTerminalAppListApi = (params) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/access/page`, params })

// 获取终端应用列表选项
export const getTerminalAppOptionsApi = () => live_instance({method: 'get', url: `/live/v2/api/web/iptv/protocol/list`, })

// 添加终端应用
export const addTerminalAppApi = (data) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/access`, data, type: 'json' })

// 编辑终端应用
export const editTerminalAppApi = (data) => live_instance({method: 'put', url: `/live/v2/api/web/iptv/access`, data, type: 'json' })

// 上传终端应用
export const uploadTerminalAppApi = (data) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/access/import`, data, type: 'upload' })

// 删除终端应用
export const deleteTerminalAppApi = (user) => live_instance({method: 'delete', url: `/live/v2/api/web/iptv/access/${user}`, })



/**===========================================================主菜单内容关联=================================================================== */
// 获取主菜单内容关联列表
export const getMainMenuListApi = (params) => live_instance({method: 'get', url: `/agent/menu-agent/page`, params })

// 添加主菜单内容关联
export const addMainMenuApi = (data) => live_instance({method: 'post', url: `/agent/menu-agent`, data, type: 'json' })

// 编辑主菜单内容关联
export const editMainMenuApi = (data) => live_instance({method: 'put', url: `/agent/menu-agent`, data, type: 'json' })

// 删除主菜单内容关联
export const deleteMainMenuApi = (id) => live_instance({method: 'delete', url: `/agent/menu-agent/${id}`  })

// 获取主菜单品牌信息
export const getMainMenuBrandApi = (id) => live_instance({method: 'get', url: `/agent/menu-agent/${id}`  })


/**=====================================================================防盗链监控============================================================================ */
// 获取账号/Sn异常列表
export const getAccountSNErrorListApi = (params) => live_instance({method: 'get', url: `/live-operation/abnormal/record/user/page`, params  })

// 获取IP异常列表
export const getIpErrorListApi = (params) => live_instance({method: 'get', url: `/live-operation/abnormal/record/ip/page`, params  })

// 加入IP黑名单
export const addIpBlackListApi = (data) => live_instance({method: 'post', url: `/live-operation/blacklist/ip`, data, type: 'json' })

// 移除IP黑名单
export const deleteIpBlackListApi = (ip) => live_instance({method: 'delete', url: `/live-operation/blacklist/ip`,  params: {ip}  })

// 编辑IP黑名单
export const editIpBlackListApi = (data) => live_instance({method: 'put', url: `/live-operation/blacklist/ip`, data, type: 'json' })

// 加入账号sn黑名单
export const addAccountSnBlackListApi = (data) => live_instance({method: 'post', url: `/live-operation/blacklist/user`, data, type: 'json' })

// 移除账号sn黑名单
export const deleteAccountSnBlackListApi = (id) => live_instance({method: 'delete', url: `/live-operation/blacklist/user/${id}`,   })

// 编辑账号sn黑名单
export const editAccountSnBlackListApi = (data) => live_instance({method: 'put', url: `/live-operation/blacklist/user`, data, type: 'json' })

// 批量编辑接口：仅更新请求体中出现的处置方式和备注字段。
export const batchEditAccountSnBlackListApi = (data) => live_instance({method: 'put', url: `/live-operation/blacklist/user/batch`, data, type: 'json' })

// 批量删除接口：请求体为黑名单记录 id 数组。
export const batchDeleteAccountSnBlackListApi = (ids) => live_instance({method: 'delete', url: `/live-operation/blacklist/user/batch`, data: ids, type: 'json' })

// 获取账号SN黑名单
export const getAccoutSnBlacklistApi = (params) => live_instance({method: 'get', url: `/live-operation/blacklist/user/page`, params  })

// 导出接口按 Blob 接收，通过响应头中的 Content-Disposition 获取 xlsx 文件名。
export const exportAccountSnBlacklistApi = (data) => axiosFileBlob_live({method: 'post', url: `/live-operation/blacklist/user/export`, data, type: 'json' })

// 获取IP黑名单
export const getIpBlacklistApi = (params) => live_instance({method: 'get', url: `/live-operation/blacklist/ip/page`, params  })

// 获取防盗链分析列表
export const getAnalysisListApi = (params) => live_instance({method: 'get', url: `/live-operation/analysis/record/page`, params  })

// 根据UserID删除
export const deleteByUserIdApi = (userId) => live_instance({method: 'delete', url: `/live-operation/blacklist/user`, params: {userId}   })

// 账号SN黑名单-下发配置
export const dispatchAccountSnBlackListApi = (data) => live_instance({ method: 'post', url: `/live-operation/blacklist/deploy`, data, type: 'json' })

// 账号SN黑名单-查询下发历史
export const getAccountSnDispatchHistoryApi = (params) => live_instance({ method: 'get', url: `/live-operation/blacklist/deploy/history/page`, params })

// 账号SN黑名单-获取处置域名配置
export const getBlackListDisposalDomainApi = () => live_instance({ method: 'get', url: `/live-operation/blacklist/strategy/list` })

// 账号SN黑名单-保存处置域名配置
export const saveBlackListDisposalDomainApi = (data) => live_instance({ method: 'put', url: `/live-operation/blacklist/strategy`, data, type: 'json' })

// 账号SN黑名单-获取处置方式类型下拉选项
export const getBlacklistStrategyTypeOptionsApi = () => live_instance({ method: 'get', url: `/live-operation/blacklist/strategy/type/options` })

// 账号SN黑名单-获取处置方式下拉选项
export const getBlacklistStrategyOptionsApi = () => live_instance({ method: 'get', url: `/live-operation/blacklist/strategy/options` })

// 盗链异常列表（分页）
export const getPiracyRecordPageApi = (params) => live_instance({ method: 'get', url: `/live-operation/abnormal/record/piracy/page`, params })

// 盗链异常详情
export const getPiracyRecordDetailApi = (id) => live_instance({ method: 'get', url: `/live-operation/abnormal/record/piracy/${id}` })


/**==============================================导入MAC========================================== */
// 获取mac订单分页
export const getMacOrderListApi = (params) => live_instance({method: 'get', url: `/live/api/web/account/mac/order/page`, params  })

// 导入MAC
export const importMacApi = ( macOrderId ,data) => live_instance({method: 'post', url: `/live/api/web/account/mac/import`, params: {macOrderId},
     data, type: 'upload' })

// 下载模板
export const downloadMacTemplateApi = () => live_instance({method: 'get', url: `/live/api/web/account/mac/templates`,  })

// 添加订单
export const createMacOrderApi = (data) => live_instance({method: 'post', url: `/live/api/web/account/mac/order`, data, type: 'json' })

// 获取MAC详情列表（根据订单ID）
export const getMacDetailListApi = (params) => live_instance({method: 'get', url: `/live/api/web/account/mac/detail/page`, params  })

// 获取dash分片列表
export const getDashLogListApi = (params) => live_instance({method: 'get', url: `/lts-dash-report/list`, params,  })

export const getCusBrandApi = (params) => live_instance({method: 'get', url: `/live/v2/api/web/iptv/server/getBrand`, params,type: 'json'  })

export const getServerConfigApi = (params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/server/getServerConfig`, data:params,type: 'json'  })

export const deleteServerConfigApi = (params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/server/deleteServerConfig`, data:params,type: 'json'  })

export const addServerConfigApi = (params) => live_instance({method: 'post', url: `/live/v2/api/web/iptv/server/addServerConfig`, data:params,type: 'json'  })